import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Utils
import { baseErrorCond } from '@toolkit/util/app';
import { cond, verifyProperty } from '@src/shared/src/util/general';
import { useTranslation } from 'react-i18next';
import { formatOnlyDate } from '@src/shared/src/util/date';
// Constants
// Services
// Models, Stores & Interfaces
import { IRootState } from '@src/store';
import { usersActions } from '@src/shared/src/actions';
// Components
import { Link, MenuListDevider, Modal } from '@toolkit/ui';
import SearchBarGuestForm from './SearchBarGuestForm';
import { HailIcon } from '@toolkit/ui/icons';

const SearchBarGuestCreator: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [formModalVisible, setFormModalVisible] = React.useState(false);
  const appSettingsMembershipCards = useSelector(
    (state: IRootState) => state.appSettings.config.membershipCards,
  );
  const userTitles = useSelector((state: IRootState) => state.appSettings.config.userTitles);

  const handleSubmit = (values: any) => {
    dispatch(
      usersActions.createGuestUserAsync.request({
        onSuccess: () => setFormModalVisible(false),
        onError: (err) => {
          setFormModalVisible(false);
          return cond(baseErrorCond)(err);
        },
        firstName: verifyProperty('', values, ['createGuest', 'firstName']),
        lastName: verifyProperty('', values, ['createGuest', 'lastName']),
        title: verifyProperty('', values, ['createGuest', 'title']),
        birthdateOn: verifyProperty(undefined, values, ['createGuest', 'birthdateOn'])
          ? formatOnlyDate(values.createGuest.birthdateOn.toISOString())
          : undefined,
        gender: verifyProperty('', values, ['createGuest', 'gender']),
        appliesTo: verifyProperty(undefined, values, ['addCard', 'appliesTo']),
        cardIdent: verifyProperty(undefined, values, ['addCard', 'cardIdent']),
        cardNumber: verifyProperty(undefined, values, ['addCard', 'cardNumber']),
      }),
    );
  };

  return (
    <React.Fragment>
      <MenuListDevider />
      <Link onClick={() => setFormModalVisible(true)} icon={<HailIcon />}>
        {t('search.bar.passengers.link.addGuestTravellers')}
      </Link>
      <Modal
        isOpen={formModalVisible}
        onClose={() => setFormModalVisible(false)}
        title={t('search.bar.passengers.link.addGuestTravellers')}>
        <SearchBarGuestForm
          appSettingsMembershipCards={appSettingsMembershipCards}
          userTitles={userTitles}
          onSubmit={handleSubmit}
        />
      </Modal>
    </React.Fragment>
  );
};

export default SearchBarGuestCreator;
